<template lang="pug">
  .cart-email-capture-modal
    form#cart-email-capture-modal-form(name="emailCaptureModalForm" @submit.prevent="captureEmail" data-mr-ass="free-shipping-form")
      template(v-if="view === 'form'")
        fieldset.form-fields
          p.title.text-center.color-blue.light.upper.xs-f-xxgrande.sm-f-xxxgrande.max-at-tweak.xs-mb-50m {{settings.title}}
          p.subtitle.text-center.semi-bold.xs-f-medium.sm-f-xmedium.max-at-tweak.xs-mb-50m {{settings.subtitle}}
          p.description.text-center.capture-text.xs-f-small.md-f-medium.lg-f-small.max-at-tweak.xs-mb-50m {{settings.description}}
          mrInput.input.xs-mt-100m(v-model="$v.email.$model" :v="$v.email" :inputType="'email'" :label="'Email'" :required="true" :disabled="capturing" data-mr-ass="free-shipping-input")
          button.submit.mr-btn.xs-f-xsmall.max-at-tweak.full-width.max-at-tweak.xs-mt-100m(type='submit' :disabled="$v.$invalid" data-mr-ass="free-shipping-submit") yes, please
          button.cancel.btn-link.underline.xs-f-small.md-f-medium.lg-f-small.max-at-tweak.xs-mt-100m(@click="close") No Thanks

      template(v-else-if="view === 'ineligible'") 
        output.error.xs-12.text-center
          p.xs-f-small.md-f-medium.lg-f-small.max-at-tweak {{settings.existingCustomerErrorText}}

      template(v-else)
        output.success.xs-12.text-center
          p.xs-f-small.md-f-medium.lg-f-small.max-at-tweak(data-mr-ass="free-shipping-success") {{settings.successText}}

    .disclaimer.xs-12.text-center.xs-mt-150m.sm-mt-500m.sm-mb-150m
      p.xs-f-xsmall.md-f-small.lg-f-xsmall.max-at-tweak  {{settings.freeShippingDisclaimerText}}

</template>

<script>
  import { mapActions } from 'vuex';
  import { required, email } from 'vuelidate/lib/validators';
  import { createCustomerFromEmailCapture } from '../../../services/vueCustomerSvc';
  import mrInput from './../../mrInput';

  export default {
    name: "CartEmailCaptureModal",
    
    data() {
      return {
        settings: {
          title: 'free shipping',
          subtitle: 'on gorgeous hair',
          description: 'Share your email for free shipping on your first order', 
          skip_psw: true,
          offerCode: 'FREESHIP_FO',
          existingCustomerErrorText: 'As an existing customer, FREE SHIPPING is not available to you.',
          successText: 'Your FREE SHIPPING on first purchase will be applied automatically at checkout.',
          freeShippingDisclaimerText: '*Free standard shipping on first order, valid for new customers only.',
        },
        email: '',
        capturing: false,
        emailCaptureResponse: null,
      }
    },

    components: {
      mrInput,
    },

    computed: {
      view() {
        if (this.emailCaptureResponse === null || isNaN(this.emailCaptureResponse)) {
          return 'form';
        } else if(this.emailCaptureResponse > 0) {
          return 'ineligible';
        } else {
          return 'promo applied';
        }
      },
    },

    methods: {
      ...mapActions('cart', ['loadCart']),

      captureEmail() {
        this.capturing = true;

        const payload = { 
          email: this.email, 
          skip_psw: this.settings.skip_psw, 
          offerCode: this.settings.offerCode, 
          source: 'cart_email_capture'
        };

        createCustomerFromEmailCapture(payload)
          .then(({ data = {}}) => {
            this.emailCaptureResponse = data.numOrders;
            this.loadCart();
          }).finally(()=> this.capturing = false);
      },

      close() {
        this.$emit('hide-modal');
      } 
    },

    validations: {
      email: {
        required,
        email,
      }
    }

   }
</script>

<style scoped lang="stylus">
  .cart-email-capture-modal
    #cart-email-capture-modal-form
      display flex
      flex-direction column
      justify-content center
  
      .form-fields
        padding 0 22%
        text-align center
  
      .submit
        &:disabled
          setcolor(color-disabled !important)
          background-color color-gray !important
          border 2px solid color-gray !important
          pointer-events none !important

      .cancel
        text-decoration underline

      .error
      .success
        padding 2em 5%

  @media mq-mobile
    .cart-email-capture-modal
      #cart-email-capture-modal-form
        .form-fields
          padding 0 8%
  
      .disclaimer
        margin-left 5%
        margin-right 5%
  
</style>